import {GenderTypes} from '@/enums/GenderTypes.enum';

export function extractName(doc: any, forceFullNameWithSalutation = false): string {
    if (doc.name) {
        return doc.name || '';
    }
    if (typeof doc.gender !== 'undefined') {
        if (!doc.firstName) {
            return `${GenderTypes.Record[doc.gender as GenderTypes]?.salutation || ''} ${doc.lastName || ''}`
        }
        if (forceFullNameWithSalutation) {
            return `${GenderTypes.Record[doc.gender as GenderTypes]?.salutation || ''} ${doc.firstName} ${doc.lastName || ''}`
        }
    }
    return `${doc.firstName || ''} ${doc.lastName || ''}`.trim();
}
